<template>
	<section>
		<AsiPageTitle :title="$t('customer.plural')" :icon="icons.customers" :show-create="rAdmin" @create="createDialog.open()"/>
		<CustomerList memory-key="admin-customers" ref="customerList"/>
		<CustomerCreateDialog v-if="rAdmin && createDialog.isLoaded" :open="createDialog.isOpen" @save="customerCreated()" @cancel="createDialog.close()"
		                  show-customer-select/>
	</section>
</template>

<script lang="ts">
	import {Component} from "vue-property-decorator";
	import AsiPageTitle from "@/components/common/AsiPageTitle.vue";
	import Icon from "@/plugins/icons";
	import CustomerList from "@/components/customer/admin/CustomerList.vue";
	import {mixins} from "vue-class-component";
	import RightChecks from "@/mixins/RightChecks.vue";
	import DialogHandler from "@/components/common/DialogHandler";
	import CustomerCreateDialog from "@/components/customer/admin/CustomerCreateDialog.vue";
	import UserCreateDialog from "@/components/user/UserCreateDialog.vue";

	@Component({
		components: {UserCreateDialog, CustomerCreateDialog, CustomerList, AsiPageTitle}
	})
	export default class Customers extends mixins(RightChecks) {

		private icons = Icon;
		private createDialog: DialogHandler = new DialogHandler();

		private customerCreated(): void {
			this.createDialog.close();

			let list = this.$refs.customerList;
			if (list !== undefined) {
				(this.$refs.customerList as CustomerList).reload();
			}
		}

	}
</script>

<style lang="scss" scoped>

</style>
